import { getCurrentPath } from "@faire/web--source/common/Path";
import { useMutation as useDismissReferralAdoptionNudge } from "@faire/web-api--source/api/brand-referrals/retailer/retailerToken/dismiss-referral-nudges/post-hooks";
import { useQuery as useReferralNudgesQuery } from "@faire/web-api--source/api/brand-referrals/retailer/retailerToken/referral-nudges/get-hooks";
import { IGetR2bNudgeResponse } from "@faire/web-api--source/indigofair/tradeshow/IGetR2bNudgeResponse";
import { route as boardsRoute } from "@faire/web-api--source/routes/boards";
import { route as brandPageRoute } from "@faire/web-api--source/routes/brand/brandToken";
import { route as categoryRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import { route as saleRoute } from "@faire/web-api--source/routes/flash-sale";
import { route as myBrandsRoute } from "@faire/web-api--source/routes/my-brands";
import { route as myReviewsRoute } from "@faire/web-api--source/routes/my-reviews";
import { route as productRoute } from "@faire/web-api--source/routes/product/productToken";
import { route as homeRoute } from "@faire/web-api--source/routes/root";
import { route as searchRoute } from "@faire/web-api--source/routes/search";
import { matchPath } from "react-router-dom";

import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

import { useAppNudgeStore } from "@faire/retailer-visitor-shared/features/Nudges/useAppNudgeStore";

const ELIGIBLE_PAGES = [
  homeRoute,
  searchRoute,
  categoryRoute,
  brandPageRoute,
  productRoute,
  boardsRoute,
  myBrandsRoute,
  myReviewsRoute,
  saleRoute,
];

export const isPathEligibleForReferralAdoptionNudges = (pathName?: string) => {
  const currentPathName = pathName ?? getCurrentPath().pathname;

  return !!ELIGIBLE_PAGES.find((whitelistPage) =>
    matchPath(currentPathName, {
      path: whitelistPage,
      exact: true,
    })
  );
};

export const useReferralAdoptionNudgeEligibility = () => {
  const { retailerToken } = useRetailerStore(["retailerToken"]);
  const [{ hasAcknowledgedReferralAdoptionNudge }, setAppNudgeStore] =
    useAppNudgeStore(["hasAcknowledgedReferralAdoptionNudge"]);
  const { mutateAsync: dismissNudge } = useDismissReferralAdoptionNudge();
  const { data: nudgesData } = useReferralNudgesQuery(retailerToken ?? "", {
    enabled: !!retailerToken,
  });

  const shouldShowReferralAdoptionNudge =
    !hasAcknowledgedReferralAdoptionNudge &&
    nudgesData &&
    nudgesData?.r2b_nudge_type &&
    nudgesData.r2b_nudge_type !== "R2B_NUDGE_TYPE_UNKNOWN";

  return {
    shouldShowReferralAdoptionNudge,
    nudges: nudgesData,
    nudgeVersion: nudgesData?.nudge_version,
    nudgeType: nudgesData?.r2b_nudge_type,
    nudgeData: nudgesData && getNudgeDataForType(nudgesData),
    setAppNudgeStore,
    dismissNudge,
    hasAcknowledgedReferralAdoptionNudge,
  };
};

const getNudgeDataForType = (nudges: IGetR2bNudgeResponse) => {
  switch (nudges.r2b_nudge_type) {
    case "BRAND_ACTIVATION":
      return nudges.brand_activation_data;
    case "EMPTY_SEARCH":
      return nudges.empty_search_data;
    case "R2B_INTRO":
      return nudges.r2b_intro_data;
    case "R2B_NUDGE_TYPE_UNKNOWN":
    default:
      return undefined;
  }
};
